import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import styles from './Login.module.css';

function Login() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log('🚀 Attempting login with:', formData.email);

      const loggedInUser = await login(formData);
      console.log('✅ User logged in via context:', loggedInUser);

      // ✅ FIXED: Use single /admin route + both role checks
      if (loggedInUser?.isAdmin || loggedInUser?.role === 'admin') {
        console.log('🔒 ADMIN DETECTED - redirecting to admin');
        navigate('/admin', { replace: true }); // ✅ Single route
      } else {
        console.log('👤 REGULAR USER - redirecting to dashboard');
        navigate('/dashboard', { replace: true });
      }
    } catch (error) {
      console.error('❌ Login error:', error);
      alert(error.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginFormWrapper}>
        <div className={styles.loginForm}>
          <div className={styles.header}>
            <h1>
              Welcome Back to <span className={styles.brandName}>StoneForex</span>
            </h1>
            <p className={styles.subtitle}>Access your trading dashboard</p>
          </div>

          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formGroup}>
              <label className={styles.label}>Email Address *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className={styles.inputField}
                disabled={loading}
              />
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>Password *</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                className={styles.inputField}
                disabled={loading}
              />
            </div>

            <button type="submit" disabled={loading} className={styles.loginButton}>
              {loading ? 'Signing In...' : 'SIGN IN'}
            </button>
          </form>

          <div className={styles.footer}>
            <p>
              Don&apos;t have an account?{' '}
              <a href="/create-account" className={styles.registerLink}>
                Create Account
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
